import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { DialogView } from "../../../../components/DialogView"
import { displayedMessage } from "./messageHelpers"

export default function MsgModal({ open, onClose, row }) {
  const { t } = useTranslation()
  if (!row) return null

  const summary = row.raw_response_summary
  // raw_response_summary can be a string or an object; stringify objects for readability.
  const summaryText =
    typeof summary === "string"
      ? summary
      : summary
        ? JSON.stringify(summary, null, 2)
        : ""

  const message = displayedMessage(row)

  // DialogView's setOpen receives a boolean. Adapt our `onClose()` callback to match.
  const setOpen = (open) => {
    if (!open) onClose()
  }

  return (
    <DialogView open={open} setOpen={setOpen} closeOnBackdrop>
      <div className="space-y-3">
        <h3 className="text-lg font-semibold">
          {t("natura_operations.nfe_status.col_order")}: <span className="font-mono">{row.order_number}</span>
        </h3>

        <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
          <div className="text-gray-500">{t("natura_operations.nfe_status.col_status")}</div>
          <div>{row.status_code ?? "—"}</div>

          <div className="text-gray-500">{t("natura_operations.nfe_status.col_action")}</div>
          <div>{row.action ?? "—"}</div>

          <div className="text-gray-500">{t("natura_operations.nfe_status.col_description")}</div>
          <div>{row.description ?? "—"}</div>
        </div>

        {message && (
          <div>
            <div className="text-xs text-gray-500 mb-1">{t("natura_operations.nfe_status.col_message")}</div>
            <div className="text-sm whitespace-pre-wrap break-words">{message}</div>
          </div>
        )}

        {summaryText && (
          <div>
            <div className="text-xs text-gray-500 mb-1">{t("natura_operations.nfe_status.modal_raw_label")}</div>
            <pre className="text-xs bg-gray-50 border border-gray-200 rounded p-2 overflow-x-auto whitespace-pre-wrap break-words">
              {summaryText}
            </pre>
          </div>
        )}

        <div className="flex justify-end pt-2">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-sm rounded bg-gray-100 hover:bg-gray-200"
          >
            {t("natura_operations.nfe_status.close")}
          </button>
        </div>
      </div>
    </DialogView>
  )
}

MsgModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  row: PropTypes.object,
}
